import {
AfterViewInit,
Component,
ContentChild,
ElementRef,
EventEmitter,
Input,
OnChanges,
OnDestroy,
Output,
SimpleChanges,
TemplateRef,
ViewChild,
ViewContainerRef
} from '@angular/core';

import { ActPopOver } from './pop-over';
import { GoogleMapsAPIWrapper } from '../services/google-maps-api-wrapper';
import { InfoMarkerManager } from '../services/managers/info-marker-manager';
import { MapsAPILoader } from '../services/maps-api-loader/maps-api-loader';

declare var System: any;
// tslint:disable
@Component({
  selector: 'act-info-marker',
  template: `
  <div id="outWrapper" #outerWrapper>
    <div style="display: none;" #viewContainer>
      <ng-content></ng-content>
    </div>
  </div>
  `
})
export class ActInfoMarker implements AfterViewInit, OnDestroy, OnChanges {
  @Input() key: String = "Marker";
  @Input() keyCenter: string = 'center';
  @Input() latitude: number;
  @Input() longitude: number;
  @Input() placement: 'top' | 'bottom' | 'left' | 'right' = 'top';
  @Input() maxWidth: number | string = 200;
  @Input() maxHeight: number | string = 200;
  @Input() backgroundColor: string;
  @Input() padding: string;
  @Input() border: { width: string; color: string } | boolean;
  @Input() borderRadius: string;
  @Input() fontColor: string;
  @Input() fontSize: string;
  @Input() pointer: string | boolean;
  @Input() shadow: boolean | { h?: string, v?: string, blur: string, spread: string, opacity: number, color: string };
  @Input() wrapperClass: string;
  @Input() showCloseButton: boolean = false;
  @Input() panOnOpen: boolean = true;
  @Input() isFirstActive: boolean = false;
  @Input() enablePopOver: boolean = true;
  @Input() isAllPopOverComplete: boolean;
  @Input() isPoi: boolean = false;

  @Output() isOpenChange: EventEmitter<boolean> = new EventEmitter<boolean>();
  @Output() beforeOpen: EventEmitter<void> = new EventEmitter<void>();
  @Output() afterClose: EventEmitter<void> = new EventEmitter<void>();
  @Output() onClick: EventEmitter<any> = new EventEmitter<any>();
  @Output() onRenderMarkerComplete: EventEmitter<any> = new EventEmitter<any>();


  @ViewChild('outerWrapper', { read: ElementRef }) _outerWrapper: ElementRef;
  @ViewChild('viewContainer', { read: ViewContainerRef }) _viewContainerRef: ViewContainerRef;
  @ContentChild(TemplateRef) _templateRef: TemplateRef<any>;

  _popOver: ActPopOver;
  isOpen: boolean = true;
  closeOnMapClick: boolean = false;

  protected _nativeInfoMarker: any;
  protected _infoMarkerInitialized: Promise<any> | null = null;

  constructor(
    private _wrapper: GoogleMapsAPIWrapper,
    private _manager: InfoMarkerManager,
    private _loader: MapsAPILoader
  ) { }

  ngOnChanges(changes: SimpleChanges) {
    if (this._nativeInfoMarker == null) {
      return;
    }
    if ('isOpen' in changes && this.isOpen) {
      this._openInfoWindow();
    } else if ('isOpen' in changes && !this.isOpen) {
      this._closeInfoWindow();
    }
    if ('latitude' in changes || 'longitude' in changes) {
      this._updatePosition();
    }
    if ('isAllPopOverComplete' in changes && this.isAllPopOverComplete) {
      this._popOver = !this.isPoi && this._manager.getPopOver(this.key);
    }
  }

  ngAfterViewInit() {
    if(this.isPoi){
      this.createPoiInfoMarker();
    }else{
      this.createInfoMarker();
    }

    setTimeout(() => {
      this.onRenderMarkerComplete.emit(this.key);
    }, 500);
  }

  protected createInfoMarker() {
    this._infoMarkerInitialized = this._loader.load()
    .then(() => System.import('../pop-over.js'))
    .then((module: any) => Promise.all([module, null, this._wrapper.getNativeMap()]))
    .then((elems) => {
      const options: any = {
        classPrefix: 'info-marker-',
        eventPrefix: 'info-marker-window-',
        map: elems[2],
        content: '',
        placement: this.placement,
        maxWidth: this.maxWidth,
        maxHeight: this.maxHeight,
        backgroundColor: this.backgroundColor,
        padding: this.padding,
        border: this.border,
        borderRadius: this.borderRadius,
        fontColor: this.fontColor,
        pointer: this.pointer,
        shadow: false,
        closeOnMapClick: this.closeOnMapClick,
        closeWhenOthersOpen: false,
        showCloseButton: false,
        isHandleBackground: true,
        panOnOpen: this.panOnOpen,
        wrapperClass: this.wrapperClass,
        callbacks: {
          beforeOpen: () => {
            this._createViewContent();
            this.beforeOpen.emit();
          },
          afterOpen: () => {
            this.isFirstActive && this.addActive();
            this.isOpenChange.emit(this.openStatus());
          },
          afterClose: () => {
            this.afterClose.emit();
            this.isOpenChange.emit(this.openStatus());
          },
          bgClicked: () => {
            this.addActive();
            // const marker = this._manager.getMarker(this.keyCenter);
            // this.isFirstActive && marker.removeActive();
            this.onClick.emit({ key: this.key });
            // this._popOver && this._popOver.togglePopOver();
            this.enablePopOver && this._popOver && this._popOver.openPopOver();
          },
          bgHoverEnter: () => {
            // this.enablePopOver && this._popOver && this._popOver.openPopOver();
          },
          bgHoverLeave: () => {
            // this._popOver && this._popOver.closePopOver();
          }
        }
      };
      if (elems[1] != null) {
        options.marker = elems[1];
      } else {
        options.position = {
          lat: this.latitude,
          lng: this.longitude
        };
      }
      this._nativeInfoMarker = new elems[0](options);
    });
    this._infoMarkerInitialized.then(() => {
      if (this.isOpen) {
        this._openInfoWindow();
      }
      this._manager.addInfoMarker(this.key, this);
    });
  }

  protected createPoiInfoMarker() {
    this._infoMarkerInitialized = this._loader.load()
    .then(() => System.import('../pop-over.js'))
    .then((module: any) => Promise.all([module, null, this._wrapper.getNativeMap()]))
    .then((elems) => {
      const options: any = {
        classPrefix: 'info-marker-',
        eventPrefix: 'info-marker-window-',
        map: elems[2],
        content: '',
        placement: this.placement,
        maxWidth: this.maxWidth,
        maxHeight: this.maxHeight,
        backgroundColor: 'transparent',
        padding: this.padding,
        border: false,
        borderRadius: false,
        fontColor: this.fontColor,
        pointer: false,
        shadow: false,
        closeOnMapClick: this.closeOnMapClick,
        closeWhenOthersOpen: false,
        showCloseButton: false,
        isHandleBackground: true,
        panOnOpen: this.panOnOpen,
        wrapperClass: this.wrapperClass,
        callbacks: {
          beforeOpen: () => {
            this._createViewContent();
            this.beforeOpen.emit();
          },
          afterOpen: () => {
            this.isFirstActive && this.addActive();
            this.isOpenChange.emit(this.openStatus());
          },
          afterClose: () => {
            this.afterClose.emit();
            this.isOpenChange.emit(this.openStatus());
          },
          bgClicked: () => {
            this.addActive();
            // const marker = this._manager.getMarker(this.keyCenter);
            // this.isFirstActive && marker.removeActive();
            this.onClick.emit({ key: this.key });
            // this._popOver && this._popOver.togglePopOver();
          },
          bgHoverEnter: () => {
            // this.enablePopOver && this._popOver && this._popOver.openPopOver();
          },
          bgHoverLeave: () => {
            // this._popOver && this._popOver.closePopOver();
          }
        }
      };
      if (elems[1] != null) {
        options.marker = elems[1];
      } else {
        options.position = {
          lat: this.latitude,
          lng: this.longitude
        };
      }
      this._nativeInfoMarker = new elems[0](options);
    });
    this._infoMarkerInitialized.then(() => {
      if (this.isOpen) {
        this._openInfoWindow();
      }
      this._manager.addInfoMarker(this.key, this);
    });
  }

  protected _openInfoWindow() {
    this._infoMarkerInitialized.then(() => {
      this._createViewContent();
      this._nativeInfoMarker.open();
    });
  }

  protected _closeInfoWindow() {
    this._infoMarkerInitialized.then(() => {
      this._nativeInfoMarker.close();
    });
  }

  protected _createViewContent() {
    if (this._viewContainerRef.length === 1) {
      return;
    }
    const evr = this._viewContainerRef.createEmbeddedView(this._templateRef);
    this._nativeInfoMarker.setContent(this._outerWrapper.nativeElement);
    // we have to run this in a separate cycle.
    setTimeout(() => {
      evr.detectChanges();
    });
  }

  protected _updatePosition() {
    this._nativeInfoMarker.setPosition({
      lat: this.latitude,
      lng: this.longitude
    });
  }

  openStatus(): boolean {
    return this._nativeInfoMarker && this._nativeInfoMarker.isOpen();
  }

  getMap() {
    return this._nativeInfoMarker.map;
  }

  addActive() {
    const { _html } = this._nativeInfoMarker || { _html: undefined };
    const { contentWrapper } = _html || { contentWrapper: undefined };
    const { classList } = contentWrapper || { classList: undefined };
    if (classList) {
      classList.add('-active');
    }
  }

  removeActive() {
    const { _html } = this._nativeInfoMarker || { _html: undefined };
    const { contentWrapper } = _html || { contentWrapper: undefined };
    const { classList } = contentWrapper || { classList: undefined };
    if (classList) {
      classList.remove('-active');
    }
  }

  ngOnDestroy() {
    if (this._nativeInfoMarker) {
      this._manager.deleteInfoMarker(this.key);
      this._nativeInfoMarker.destroy();
    }
  }

  setActiveMarker(active: boolean) {
    active ? this.addActive() : this.removeActive();
  }
}



// WEBPACK FOOTER //
// ./src/app/utilities/act-map/directives/info-marker.ts